module.exports = __webpack_public_path__ + "img/16.bfb97c1d.png";